import { render } from "./SpeseAggiuntive.vue?vue&type=template&id=93f5c6e6"
import script from "./SpeseAggiuntive.vue?vue&type=script&lang=js"
export * from "./SpeseAggiuntive.vue?vue&type=script&lang=js"

import "./SpeseAggiuntive.vue?vue&type=style&index=0&id=93f5c6e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__